import { motion } from 'framer-motion';

const reasons = [
  {
    icon: 'ri-map-pin-2-fill',
    title: 'Regional verwurzelt',
    description:
      'Als Webdesigner aus dem Schwarzwald kenne ich den Freiburger Markt und die Bedürfnisse regionaler Unternehmen genau.',
  },
  {
    icon: 'ri-timer-flash-line',
    title: 'Fertig in 1 Woche',
    description:
      'Keine monatelangen Wartezeiten. Ihre professionelle Webseite ist in maximal einer Woche live – garantiert.',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Festpreis 899 €',
    description:
      'Ein transparenter Festpreis, keine versteckten Kosten. Alles inklusive – von SEO bis DSGVO-Absicherung.',
  },
  {
    icon: 'ri-robot-2-line',
    title: 'AI-Technologie',
    description:
      'Modernste AI-Chatbots und Automatisierungen, die Ihre Freiburger Kunden rund um die Uhr betreuen.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Persönlicher Kontakt',
    description:
      'Kein Callcenter, kein Projektmanager-Wirrwarr. Sie sprechen direkt mit mir – von Anfang bis Ende.',
  },
  {
    icon: 'ri-shield-check-line',
    title: '100 % Zufriedenheitsgarantie',
    description:
      'Ich liefere erst ab, wenn Sie vollständig zufrieden sind. Ihr Erfolg ist mein Anspruch.',
  },
];

export default function FreiburgWhyUs() {
  return (
    <section className="py-20 sm:py-28 bg-brand-beige-light relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-brand-green/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-brand-beige/40 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="inline-block bg-brand-green/10 text-brand-green text-xs font-semibold px-4 py-1.5 rounded-full mb-4 uppercase tracking-wider">
            Warum BR Webdesign?
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-caprasimo text-brand-black mb-4">
            Ihr Vorteil in Freiburg
          </h2>
          <p className="text-lg text-brand-grey max-w-2xl mx-auto">
            Webdesign Freiburg – professionell, schnell und zu einem fairen Festpreis.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {reasons.map((r, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              viewport={{ once: true }}
              className="bg-white rounded-2xl p-7 group hover:shadow-xl transition-all border border-transparent hover:border-brand-green/30"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-brand-beige-light rounded-xl mb-5 group-hover:bg-brand-green group-hover:scale-110 transition-all">
                <i className={`${r.icon} text-2xl text-brand-green group-hover:text-white transition-colors`} />
              </div>
              <h3 className="text-lg font-caprasimo text-brand-black mb-3 group-hover:text-brand-green transition-colors">
                {r.title}
              </h3>
              <p className="text-brand-grey text-sm leading-relaxed">{r.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
